export default "__VITE_ASSET__tGPW67TO__"